import { useRestrictionsQuery } from '../../generated/graphql';
import useConcession from '../../hooks/useConcession';
import { FilterProps } from '../../types/types';
import { SelectFilter } from '../SelectFilter/SelectFilter';

export default function RestrictionFilter(props: FilterProps) {
    const { value, onChange, width = 150 } = props
    const query = useRestrictionsQuery
    const concession = useConcession()

    return (
        <SelectFilter
            value={value}
            onChange={onChange}
            label="Condicionalismo"
            query={query}
            field="restriction"
            filter={{ concession: { id: { eq: concession?.id } } }}
            multiple={true}
            paging={{ limit: 999 }}
            width={width}
        />
    )
}
